// flow weak

import React, {
    Component
  }                             from 'react';
  import PropTypes              from 'prop-types';
  import AnimatedView           from '../../../../components';
  import styles                 from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../../services/fetchTools';
  import { withRouter } from 'react-router';
  import DatePicker from 'react-datepicker';
  import moment from 'moment';
  import styled from 'styled-components'
  import FlatButton from 'material-ui/FlatButton';
  import Dialog from 'material-ui/Dialog'
  import { Spinner } from 'react-activity';
  import 'react-activity/dist/react-activity.css';
  import { Multiselect } from 'react-widgets';
  import TimePicker from 'react-times';
  import {Link} from 'react-router-dom';
  import ReactTable from "react-table";
  
  class UnconfirmedAllocations extends Component {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = {
        venue:props.props.statsTable.revenue_per_month.requested_venue_id,
        session_data:[],
        headers:[],
        session_buddies:[],
        selected_buddies:[],
        selected_buddies_id:[],
        da_list:[],
        buddies:[],
        temp_buddies:[],
        desk_associates:[],
        desk_details:[],
        all_da:[],
        selected_da:[],
        session_id:'',
        daily_alloc_id:'',
        activity_state:true,
        is_buddy_selected:true,
        is_da_selected:false,
        buddy_dialog:false,
        da_dialog:false,
        desk_associate:'',
        start_time:'',
        end_time:'',
        date:''
      };
      this.onSelect = this.onSelect.bind(this);
      this.onChange = this.onChange.bind(this);
      this.postBuddies = this.postBuddies.bind(this);
      this.onStartTimeChange = this.onStartTimeChange.bind(this);
      this.onEndTimeChange = this.onEndTimeChange.bind(this);
      this.handleChange = this.handleChange.bind(this);
      this.postDesk = this.postDesk.bind(this);
      this.getSession = this.getSession.bind(this);
      this.handleBuddy = this.handleBuddy.bind(this);
    }
  
    componentDidMount(){
        this.getSession()
        // this.getBuddies()
        this.getData()
        this.getDAs()
        this.getDetails()
        console.log("componentDidMount")
        console.log(this.state)
    }

    locationChanged() {
      this.setState({venue:this.props.props.statsTable.revenue_per_month.requested_venue_id}, () => {
        // this.getBuddies()
        this.getData()
        this.getDAs()

      })
    }

    // getBuddies(){
        

    //     const url = `${getLocationOrigin()}/cm/get_allocated_buddies/?venue_id=${this.state.venue}`;
    //     const options = {...defaultOptions};

    //     return fetch(url, options)
    //     .then(checkStatus)
    //     .then(parseJSON)
    //     .then(data => {
    //         console.log('result',data)
    //         this.setState({session_buddies:data.result[0],activity_state:false});
    //     }).catch(error => error);
    // }
    getSession(){
      const url = `${getLocationOrigin()}/cm/get_upcoming_session_details/?venue_id=${this.state.venue}`;
        const options = {...defaultOptions};

        return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => {
            console.log('result',data)
            this.setState({activity_state:false,session_data:data.result});
        }).catch(error => error);
    }

    postBuddyChange(buddies,session_id){
      const url = `${getLocationOrigin()}/cm/allocate_buddy_to_session/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                          'buddies': buddies,
                          'session_id': session_id,
                        });
      return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(data => {
          if(data.success){
            alert(data.message)
            this.setState({buddy_dialog:false},()=>{this.getBuddies()})
            
          }
          else{
            this.setState({buddy_dialog:false})
            alert(data.message)
          }

      }).catch(error => error);
    }

    postDAChange(allocation_id,desk_associate,start_time,end_time,date){
      const url = `${getLocationOrigin()}/cm/update_desk_allocation/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                          'allocation_id': allocation_id,
                          'desk_associate': desk_associate,
                          'start_time':start_time,
                          'end_time':end_time,
                          'date':date
                        });
      return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(data => {
          if(data.success){
            alert(data.message)
            this.setState({da_dialog:false},()=>{this.getDAs()})
            
          }
          else{
            this.setState({da_dialog:false})
            alert(data.message)
          }

      }).catch(error => error);
    }

    getData(){
        const url = `${getLocationOrigin()}/cm/get_buddies/?venue_id=${this.state.venue}`;
        const options = {...defaultOptions};

        return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => {
            console.log('result',data)
            this.setState({buddies:data.buddies});
        }).catch(error => error);
    }

    getDAs(){
        const url = `${getLocationOrigin()}/cm/get_allocated_da/?venue_id=${this.state.venue}`;
        const options = {...defaultOptions};

        return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => {
            console.log('desk_associates',data)
            this.setState({desk_associates:data.desk_associates});
        }).catch(error => error);
    }

    getDetails(){
      const url = `${getLocationOrigin()}/cm/get_details_for_da_allocation/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            if(data.success){
              this.setState({success:data.success,desk_result:data.result})
            }
            else{
              this.setState({success:data.success,message:data.message})
            }
           // alert("fix");
       }).catch(error => error);
    }

    onSelect(optionsList, selectedItem) {
        this.state.temp_buddies.push(optionsList)
        this.setState({ selected_buddies: this.state.temp_buddies});
    }

    onChange(dataItem,event){
      this.setState({selected_buddies:dataItem.map(x =>x)});
    }

    selectedButton(tag) {
      if(tag==='da'){
        this.setState({is_da_selected:true,is_buddy_selected:false})
      }
      else{
        this.setState({is_buddy_selected:true,is_da_selected:false})
      }
    }

    handleBuddy(event) {
      var session_id = event.target.value
      console.log('session_id',session_id)
      var bud_ids = this.state.session_data.find(session => session.id == session_id)
      console.log('bud_ids',bud_ids.buddy)
      const sel_buds = this.state.buddies.filter(buddy=> bud_ids.buddy.includes(buddy.buddy))
      console.log('sel_buds',sel_buds)
      this.setState({selected_buddies:sel_buds,session_id:session_id,buddy_dialog:true})
    }

    handleDA(id){
      var daily_data = this.state.desk_associates.find(da=>da.id==id)
      console.log('daily_data',daily_data)
      var filter_data = this.state.desk_result.find(ven=>ven.name == daily_data.venue)
      console.log('filter_data',filter_data)
      this.setState({all_da:filter_data.desk_associates,daily_alloc_id:id,da_dialog:true,selected_da:daily_data, date:daily_data.date,
        start_time:daily_data.start_time.substring(0,5),end_time:daily_data.end_time.substring(0,5), desk_associate:daily_data.buddy_id})
    }

    onStartTimeChange(options) {
    console.log('options',options)
    this.setState({start_time: options});
    }

    onEndTimeChange(options) {
    console.log('options',options)
    this.setState({end_time: options});
    }

    postBuddies(){
      var bud_ids = []
      for( var i in this.state.selected_buddies)
      {
        bud_ids.push(this.state.selected_buddies[i].id)
      }
      console.log('ids',bud_ids)
      this.postBuddyChange(bud_ids,this.state.session_id)
    }

    postDesk(){
      this.postDAChange(this.state.daily_alloc_id,this.state.desk_associate,this.state.start_time,this.state.end_time,this.state.date)
    }

    handleOpen=()=>{
      this.setState({buddy_dialog:true})
    }
    handleClose=()=>{
      this.setState({buddy_dialog:false})
    }

    handleDAOpen=()=>{
      this.setState({da_dialog:true})
    }
    handleDAClose=()=>{
      this.setState({da_dialog:false})
    }

    handleChange(event){
      var value = event.target.value
      console.log('desk_associate',value)
      this.setState({desk_associate:value})
    }
    getTrProps = (state, rowInfo, instance) => {
      if (rowInfo && this.state.is_open_ticket_checked) {
        return {
          style: {
            background: rowInfo.row._original.time_passed > 24 ? '#ffafbd ' : 'white',
            color: rowInfo.row._original.time_passed > 24 ? 'black' : 'black'
          }
        }
      }
      return {
        style: {
          background:'white',
          color:'black'
        }
      };
    }
    
    render() {
       
        console.log('UnconfirmedAllocations',this.props)
        console.log(this.state.session_data)

        if(this.state.venue != this.props.props.statsTable.revenue_per_month.requested_venue_id){
          this.locationChanged()
        }
      
        const actions = [
            <FlatButton
              label="Cancel"
              primary={true}
              onClick={this.handleClose}
            />,
            <FlatButton
              label="Proceed"
              primary={true}
              onClick={this.postBuddies}
            />,
          ];

        const da_actions = [
            <FlatButton
              label="Cancel"
              primary={true}
              onClick={this.handleDAClose}
            />,
            <FlatButton
              label="Proceed"
              primary={true}
              onClick={this.postDesk}
            />,
          ];
      const columns =  [{  
       Header: 'Venue',  
       accessor: 'venue'  
       },{  
       Header: 'Date',  
       accessor: 'date'
       },{  
       Header: 'Type',  
       accessor: 'type'  
       },{  
       Header: 'Time',  
       accessor: 'start_time'
       },{  
       Header: 'Buddy',  
       accessor: 'buddy',
       Cell: ({row}) => (this.state.buddies.filter(buddy=>row.buddy.includes(buddy.id)).map((bud,i)=>
                                                <div>{bud.buddy}</div>
                                              ))
       },{  
       Header: 'Edit',  
       accessor: 'id',
       Cell: ({ row }) => (<button className='button1' value= {row.id} onClick={this.handleBuddy} >Edit</button>)
       }
       ]

       const da_columns =  [{  
       Header: 'Venue',  
       accessor: 'venue'  
       },{  
       Header: 'Date',  
       accessor: 'date'
       },{  
       Header: 'Name',  
       accessor: 'name'  
       },{  
       Header: 'Start Time',  
       accessor: 'start_time'
       },{  
       Header: 'End Time',  
       accessor: 'end_time'
       },{  
       Header: 'Edit',  
       accessor: 'id',
       Cell: ({ row }) => (<button className='button1' value= {row.id} onClick={this.handleDA(row.id)} >Edit</button>)
       }
       ]
            
      return(
        <div style={styles.container}>
            <div className='col-md-12' style={styles.button_cell}>
                <button className='btn btn-success' onClick={()=>{this.selectedButton('buudy')}} style={styles.button}>Buddy Allocation</button>
                <button className='btn btn-success' onClick={()=>{this.selectedButton('da')}} style={styles.button}>DA Allocation</button>
                <button className='btn btn-success' style={{backgroundColor:'#d94c71',display:'flex',justifyContent:'space-evenly'}}><Link to={`./allocation`} target="_blank" style={{color:'black'}}>Add Allocation</Link></button>
                  

            </div>
            <div style={{marginTop:10}}>
                <div className='col-md-12 table_container1 table-responsive'>
                 <ReactTable  
                  data={this.state.is_buddy_selected ? this.state.session_data : this.state.desk_associates}  
                  className="-striped -highlight"
                  columns={this.state.is_buddy_selected ? columns : da_columns}  
                  defaultPageSize = {100}  
                  pageSizeOptions = {[100,200,500]} 
                  getTrProps={this.getTrProps} 
                  filterable={true}
                  showPagination={this.state.session_data.length > 100}
                  showPaginationTop = {this.state.session_data.length > 100}
                  style = {{background:'#9370DB',textAlign:'center'}}
                  defaultFilterMethod = {(filter, row, column) => {
                    const id = filter.pivotId || filter.id
                    return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true
                  }}
                  > 
                  {
                    //To show the record count on top  
                    (state, makeTable, instance) => {

                      let recordsInfoText = "";

                      const { filtered, pageRows, pageSize, sortedData, page } = state;

                      if (sortedData && sortedData.length > 0) {
                        let isFiltered = filtered.length > 0;

                        let totalRecords = sortedData.length;

                        let recordsCountFrom = page * pageSize + 1;

                        let recordsCountTo = recordsCountFrom + pageRows.length - 1;

                        if (isFiltered){
                          recordsInfoText = `${totalRecords} filtered records`;
                        }
                        else {
                          recordsInfoText = `${totalRecords} records`;
                        }
                      } else {
                          recordsInfoText = "No records";
                        }
                      return (
                        <div className="main-grid">
                          <div className="above-table text-right">
                            <div className="col-sm-12 records-info">
                              <span className="">{recordsInfoText}</span>
                            </div>
                          </div>
                          {makeTable()}
                          
                        </div>

                      );
                    }
                  }
               </ReactTable >
          
            </div>
        </div>

                        {/*this.state.activity_state ? 
                        <div style={{position:'absolute',marginTop:'30%',marginLeft:'40%'}}>
                            <Spinner size="50" />
                        </div>
                        :
                        <div>
                          { this.state.is_buddy_selected &&
                            Object.keys(this.state.session_buddies).map((key,index) =>
                                <div className="col-md-12" style={{'padding':10,'display':"flex",'flexDirection':"column",'backgroundColor':"white",'marginTop':"2px"}}>
                                    <div style={{'display':"flex",'flexDirection':"row"}}>
                                        <div className="col-md-3" >
                                            {this.state.session_buddies[key].venue}
                                        </div>
                                        <div className="col-md-3" >
                                            {this.state.session_buddies[key].date}
                                        </div>
                                        <div className="col-md-3" >
                                            {this.state.session_buddies[key].type}
                                        </div>
                                        <div className="col-md-3" >
                                            {this.state.session_buddies[key].start_time} - {this.state.session_buddies[key].end_time}
                                        </div>
                                        <div className="col-md-3" >
                                            {this.state.buddies.filter(buddy=>this.state.session_buddies[key].buddy.includes(buddy.id)).map((bud,i)=>
                                                <div>{bud.buddy}</div>
                                              )}
                                        </div>

                                        <div className="col-md-3" >
                                          <input type="button" value="Edit"  style={{'backgroundColor':"#48CB60",'fontSize':"18px"}} />
                                        </div>
                                    </div>
                                </div>
                            )
                          }
                          { this.state.is_da_selected &&
                            Object.keys(this.state.desk_associates).map((key,index) =>
                                  <div className="col-md-12" style={{'padding':10,'display':"flex",'flexDirection':"column",'backgroundColor':"white",'marginTop':"2px"}}>
                                      <div style={{'display':"flex",'flexDirection':"row"}}>
                                          <div className="col-md-3" >
                                              {this.state.desk_associates[key].venue}
                                          </div>
                                          <div className="col-md-3" >
                                              {this.state.desk_associates[key].date}
                                          </div>
                                          <div className="col-md-3" >
                                              {this.state.desk_associates[key].name}
                                          </div>
                                          <div className="col-md-3" >
                                              {this.state.desk_associates[key].start_time} - {this.state.desk_associates[key].end_time}
                                          </div>

                                          <div className="col-md-3" >
                                            <input type="button" value="Edit" onClick={()=>this.handleDA(this.state.desk_associates[key].id)}style={{'backgroundColor':"#48CB60",'fontSize':"18px"}} />
                                          </div>
                                      </div>
                                  </div>
                            )
                          }
                        </div>
                        */}

            { this.state.buddy_dialog && this.state.selected_buddies && this.state.selected_buddies.length > 0 &&
              <div className="col-md-12">
                <Dialog
                      actions={actions}
                      modal={false}
                      open={this.state.buddy_dialog}
                      onRequestClose={this.handleClose}
                      autoDetectWindowHeight={true}
                      autoScrollBodyContent={true}
                    >
                  <div>
                    <div style={styles.main_header} className="col-md-12">
                      <h4 style={{textAlign:'center'}}> Add / Remove Buddies </h4>
                    </div>
                    <div className='col-md-12'>
                      <div style={styles.item_body,{height:'230px'}} className="col-md-6">
                        <Multiselect
                          id="1"  
                          placeholder="Buddies"
                          data={this.state.buddies}
                          value = {this.state.selected_buddies}
                          textField='buddy'
                          onSelect={this.onSelect} 
                          onChange={this.onChange}
                          filter='contains' 
                         />
                      </div> 

                      <div className='col-md-6'>
                        &larr; Click to add buddy
                      </div>
                    </div>
                    
                  </div> 
                </Dialog>
              </div>
            }

            { this.state.da_dialog && this.state.all_da && this.state.all_da.length > 0 &&
              <div className="col-md-12">
                <Dialog
                      actions={da_actions}
                      modal={false}
                      open={this.state.da_dialog}
                      onRequestClose={this.handleDAClose}
                      autoDetectWindowHeight={true}
                      autoScrollBodyContent={true}
                    >
                  <div>
                    <div style={styles.main_header} className="col-md-12">
                      <h4 style={{textAlign:'center'}}> Update DA Allocation </h4>
                    </div>
                    <div style={{marginBottom:'4%'}} className="col-md-12">
                      <div className="col-md-6">
                        Desk Associate
                      </div>
                     <select name="desk_associate" className="col-md-6" style={styles.item_body}
                       onChange={this.handleChange} value={this.state.desk_associate}>
                        { 
                           this.state.all_da.map((desk,index)=>(
                             <option key={desk.id} value={desk.id}>{desk.name} : {desk.mobile_no} </option>
                            ))
                        }
                     </select>
                    </div>

                    <div style={{height:'230px'}} className="col-md-12">
                        <div className="col-md-6">
                            <span className='col-md-3' style={{display:'contents',marginBottom:'1%'}}>Start Time </span>
                            <div style={{width:'50%'}}>
                                <TimePicker className="col-md-3" style={{width:'50%'}} theme="classic" time={this.state.start_time} name='start_time' onTimeChange={this.onStartTimeChange} />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <span className='col-md-3' style={{display:'contents',marginBottom:'1%'}}>End Time </span>
                            <div style={{width:'50%'}}>
                                <TimePicker className="col-md-3" style={{width:'50%'}} theme="classic" time={this.state.end_time} name='end_time' onTimeChange={this.onEndTimeChange} />
                            </div>
                        </div>
                    </div>
                    
                  </div> 
                </Dialog>
              </div>

            }


        </div>
      );
    }
  }
  
  export default UnconfirmedAllocations;
  


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/UnconfirmedAllocations/index.js